import Bank from "../pages/Bank";
import PosterSendOnWhatsApp from "../pages/PosterSendOnWhatsapp";
import WhatsAppGroup from "../pages/WhatsAppGroup";
import InternetStatusBanner from "../pages/InternetConnection";
import ConnectWhatsapp from "../pages/ConnectWhatsapp";
import Profile from "../pages/InternetProfile";
import Notfound from "../pages/notFound";
import ContentManage from "../pages/Manage/contentManage";
import Reports from "../pages/reports";
import ChangePassword from "../pages/changePassword";
import Address from "../pages/AddressDetails";
import FeeReceipt from "../pages/feeReceipt";
import User from "../pages/user";
import RoleMaster from "../pages/roleMaster";
import RoleMenuAccess from "../pages/roleMenuAccess";
import CreateTenant from "../pages/SuperAdmin/CreateTenants";
import Encryption from "../pages/SuperAdmin/encryption";
import Membership from "../pages/memberShip";
import Donation from "../pages/DonationComponent";
import MedicalCenter from "../pages/Medical/MedicalCenter";
import Doctor from "../pages/Medical/Doctor";
import DoctorAssociate from "../pages/Medical/DoctorAssociate.jsx";
import Department from "../pages/Medical/Department";
import SubDepartment from "../pages/Medical/SubDepartment";
import Patient from "../pages/Medical/Patient";
import Services from "../pages/Medical/Services";
import FeeSetup from "../pages/Medical/FeeSetup";
import DoctorMedicalMapping from "../pages/Medical/DoctorMedicalMapping.jsx";
import DoctorDepartment from "../pages/Medical/DoctorDepartment.jsx";
import UserMedicalCentreMapping from "../pages/Medical/UserMedicalCentreMapping.jsx";

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import ReceiptIcon from "@mui/icons-material/Receipt";
import GroupIcon from "@mui/icons-material/Group";
import PersonIcon from "@mui/icons-material/Person";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import AccountBalanceSharpIcon from "@mui/icons-material/AccountBalanceSharp";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import OutboxIcon from '@mui/icons-material/Outbox';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ConstructionIcon from "@mui/icons-material/Construction";
import LanguageIcon from "@mui/icons-material/Language";
import SummarizeIcon from "@mui/icons-material/Summarize";
import EnhancedEncryptionIcon from "@mui/icons-material/EnhancedEncryption";
import CableIcon from '@mui/icons-material/Cable';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAltSharp';

import KeyIcon from "@mui/icons-material/Key";

export const iconMap = {
    "Membership": <GroupIcon />,
    "Donation": <Donation />,
    "ReceiptIcon": <ReceiptIcon />,
    "OutboxIcon": <OutboxIcon />,
    "GroupAddIcon": <GroupAddIcon />,
    "ConstructionIcon": <ConstructionIcon />,
    "CableIcon": <CableIcon />,
    "AccountCircleIcon": <AccountCircleIcon />,
    "PersonAddAltIcon": <PersonAddAltIcon />,
    "AccountBalanceSharpIcon": <AccountBalanceSharpIcon />,
    "WhatsApp": <WhatsAppIcon />,
    "WhatsAppIcon": <WhatsAppIcon />,
    "Medical": <GroupIcon />,
    "Create SubTenant": <PersonIcon />,
    "Manage Content": <ConstructionIcon />,
    "Bank": <AccountBalanceSharpIcon />,
    "LanguageIcon": <LanguageIcon />,
    "LocationOnIcon": <LocationOnIcon />,
    "SummarizeIcon": <SummarizeIcon />,
    "EnhancedEncryptionIcon": <EnhancedEncryptionIcon />,
    "VolunteerActivismIcon": <VolunteerActivismIcon />,
    "Send Poster": <AccountBalanceSharpIcon />,
    "Connect WhatsApp": <GroupIcon />,
    "Doctor": <GroupIcon />,
    "DoctorAssociate": <GroupIcon />,
    "Department": <GroupIcon />,
    "SubDepartment": <GroupIcon />,
    "Patient": <GroupIcon />,
    "Services": <GroupIcon />,
    "FeeSetup": <GroupIcon />,
    "DoctorMedicalMapping": <GroupIcon />,
    "DoctorDepartment": <GroupIcon />,
    "UserMedicalCentreMapping": <GroupIcon />,
};

export const componentMap = {
    MedicalCenter,
    UserMedicalCentreMapping,
    Doctor,
    DoctorAssociate,
    Department,
    SubDepartment,
    Patient,
    DoctorMedicalMapping,
    DoctorDepartment,
    Services,
    FeeSetup,
    Bank,
    PosterSendOnWhatsApp,
    WhatsAppGroup,
    InternetStatusBanner,
    ConnectWhatsapp,
    Profile,
    Notfound,
    ContentManage,
    Reports,
    ChangePassword,
    Address,
    FeeReceipt,
    User,
    RoleMaster,
    RoleMenuAccess,
    // CreateUser,
    CreateTenant,
    Encryption,
    Membership,
    Donation
};
